import React from "react";
import { isEmpty } from "lodash";

import { readOnlyValue } from "../../../../../attributes/lib/attribute-data";

const AllergyInfo = (props) => {
    const contains = props.data && props.data.contains ? props.data.contains : [];
    const mayContain = props.data && props.data.mayContain ? props.data.mayContain : [];
    const doesNotContain = props.data && props.data.doesNotContain ? props.data.doesNotContain : [];

    return (
        <div>
            {!props.isAttribute && <h4 className="-tighten-margin">Allergy Information</h4>}
            {!isEmpty(contains) && <b>Contains:</b>} {readOnlyValue(contains, "MultiDropdownPicklist")}
            <br />
            {!isEmpty(mayContain) && <b>May Contain:</b>} {readOnlyValue(mayContain, "MultiDropdownPicklist")}
            {!props.isAttribute && <br />}
            <br />
            {!isEmpty(doesNotContain) && <b>Does Not Contain:</b>} {readOnlyValue(doesNotContain, "MultiDropdownPicklist")}
        </div>
    );
};

export default AllergyInfo;
